import { createSelector } from '@ngrx/store';
import { geTCFTrustInfo, geTCFTrustSign } from '@store/reducers/tcf-trust/tcf-trust.reducer';

import * as fromFeature from '../../reducers';

export const selectTCFTrustState = createSelector(fromFeature.getTCFTrustState, (state) => state);

export const selectTCFTrustInfo = createSelector(selectTCFTrustState, geTCFTrustInfo);

export const selectTCFTrustSign = createSelector(selectTCFTrustState, geTCFTrustSign);
